module.exports = __webpack_public_path__ + "static/img/4_1_laba.ba59134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4_1_laba.png
// module id = 0ATR
// module chunks = 1